import { DependencyList, useEffect, useRef, useState } from 'react';

export const useIsTableScrollable = ({ scrollXEnable, widthInPercent, width, deps = [], disable }: Props) => {
  const [isTableScrollable, setIsTableScrollable] = useState(false);

  const tableRef = useRef<HTMLDivElement>(null);
  const tableWidth = tableRef.current?.clientWidth || 0;

  useEffect(() => {
    const getIsTableScrollable = () => {
      if (scrollXEnable) {
        if (widthInPercent) {
          return widthInPercent > 100;
        }
        if (width && tableRef.current) {
          return tableRef.current?.clientWidth < parseInt(width);
        }
      }
      return false;
    };

    if (!disable) {
      setIsTableScrollable(getIsTableScrollable());
    }
  }, [scrollXEnable, widthInPercent, width, ...deps, disable]);

  return { tableRef, isTableScrollable, tableWidth };
};

interface Props {
  scrollXEnable: boolean;
  widthInPercent: number | undefined;
  width: string | undefined;
  deps?: DependencyList;
  disable: boolean;
}
